<style scoped></style>

<template>
  <div>
    <div class="relative mt-1">
      <input
        type="text"
        v-model="searchValue"
        name="manager_search"
        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        maxlength="255"
        id="manager_search"
        :placeholder="$t('editor.search_admin_placeholder')"
      />
      <ul
        v-if="searchValue"
        class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        role="listbox"
      >
        <li
          v-bind:key="searchResult.id"
          class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900"
          role="option"
          tabindex="-1"
          v-for="searchResult in searchResults"
        >
          <div class="flex justify-between">
            <span class="block truncate">{{ searchResult.full_name }}</span>
            <button
              v-if="
                !isManagerInList(searchResult) &&
                currentUser.id !== searchResult.id
              "
              type="button"
              :aria-label="$t('editor.add_as_admin', {user: searchResult.full_name})"
              class="ml-2 w-4 text-gray-500"
              @click="addManager(searchResult)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <ul class="divide-y divide-gray-200">
      <li
        v-for="manager in this.managers"
        v-bind:key="manager.id"
        class="py-4 text-sm"
      >
        <div class="flex justify-between">
          {{ manager.full_name }}
          <button
            v-if="currentUser.id !== manager.id"
            type="button"
            :aria-label="$t('editor.delete_admin')"
            class="ml-2 w-4 text-gray-500"
            @click="() => onDelete(manager.id)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </li>
    </ul>
    <input
      v-for="manager in this.managers"
      v-bind:key="manager.id"
      type="hidden"
      name="managers"
      :value="manager.id"
    />
  </div>
</template>
<script>
export default {
  name: 'AdminSelector',
  components: {},
  data() {
    return {
      managers: this.initialManagers,
      searchValue: '',
    };
  },
  methods: {
    onDelete(id) {
      this.managers = this.managers.filter((manager) => manager.id !== id);
    },
    addManager(manager) {
      this.managers.push(manager);
      this.searchValue = '';
    },
    isManagerInList(managerToSearch) {
      const results = this.managers.filter(
        (manager) => manager.id === managerToSearch.id,
      );
      return results.length > 0;
    },
  },
  computed: {
    searchResults() {
      return this.allUsers.filter((user) =>
        user.full_name.toLowerCase().includes(this.searchValue.toLowerCase()),
      );
    },
  },
  props: {
    initialManagers: Array,
    allUsers: Array,
    currentUser: Object,
  },
};
</script>
